const textCapitalization = (text: string) => {
  const newText = String(text ?? "").replace(/_/g, " ");
  return newText
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export default textCapitalization;
